<template>
    <v-container>
        <v-row>
            <v-col>
                <v-toolbar dense elevation="1" rounded color="secondary">
                    <v-breadcrumbs class="ms-n6" :items="[{text: 'Purchasing & Ordering'}, {text: 'Ordering'} ,{text: 'Edit Account',}]" large/>
                </v-toolbar>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="6">
                <v-sheet elevation="1" rounded>
                    <v-toolbar flat color="secondary">
                        <v-toolbar-title>
                            Edit Account
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items>
                            <PIconBtn icon="mdi-content-save" tooltip="Save" @click="handleSave"/>
                            <PIconBtn icon="mdi-cancel" tooltip="Discard" @click="handleDiscard"/>
                            <PIconBtn icon="mdi-delete" tooltip="Delete" @click="handleDelete" v-if="hasPermission(perm.supplier_account.delete)"/>
                        </v-toolbar-items>
                    </v-toolbar>
                    <v-divider></v-divider>
                    <SupplierAccountForm class="ma-3" ref="form" v-model="data" v-if="!loading" @submit="handleSubmit"/>
                </v-sheet>
            </v-col>
        </v-row>
        <PAlert v-model="alert.value" v-bind="alert"></PAlert>
        <LoadingOverlay :value="loading"/>
    </v-container>
</template>

<script>
import permissions from './../../data/permissions';
import PIconBtn from '../../components/common/PIconBtn.vue';
import PAlert from './../../components/common/PAlert.vue';
import LoadingOverlay from './../../components/common/LoadingOverlay.vue';
import SupplierAccountForm from '../../components/purchase/SupplierAccountForm.vue';
import { mapActions, mapGetters } from 'vuex';
export default {
    name: "SupplierAccountEditView",
    components: {
        SupplierAccountForm,
        PAlert,
        LoadingOverlay,
        PIconBtn
    },
    data() {
        return {
            id: null,
            data: null,
            alert: {
                title: "Alert",
                content: "Are you sure",
                value:  false,
                callback: null
            },
            loading: false,
            perm: permissions
        }
    },
    computed: {
        ...mapGetters({
            hasPermission: "authentication/hasPermission"
        })
    },
    methods: {
        ...mapActions({
            findByID: "purchase/supplierAccount/findByID",
            snackbar: "ui/snackbar/show",
            update: "purchase/supplierAccount/update",
            remove: "purchase/supplierAccount/remove",
            pushCurrency: "purchase/currency/push",
            pushSupplier: "purchase/supplier/push",
            pushLedgerAccount: "purchase/ledgerAccount/push"
        }),
        handleSubmit(form) {
            this.loading = true;
            this.update(form).then(response => {
                this.snackbar({ text: "Supplier Account Updated" ,color: "success"})
                this.$router.push({ name: "SupplierAccountDisplay", params: { id: response.data.id} })
            }).catch(error => {
                let message = error.response ? error.response.data.message : error;
                this.snackbar({ text: message, color: "error" })
            }).finally(() => {
                this.loading = false;
            });
        },
        handleSave() {
            this.alert = { ...this.alert, value: true, content: "Are you sure you want to save", callback: this.save}
        },
        save() {
            this.$refs.form.submit()
        },
        handleDiscard() {
            this.$router.back()
        },
        handleDelete() {
            this.alert = { ...this.alert, value: true, content: "Are you sure you want to delete account?", callback: this.deleteAsync }
        },
        deleteAsync() {
            this.loading = true;
            this.remove(this.data).then(() => {
                this.snackbar({color: "success", text: "Account Removed Successfully."});
                this.$router.push({ name: "SupplierDisplay", params: { id: this.data.supplier_id }});
            }).catch(error => {
                let message = error.response ? error.response.data.message : error;
                this.snackbar({color: "error", text: message})
            }).finally(() => {
                this.loading = false;
            });
        },
        fetchSupplierAccount() {
            this.loading = true;
            this.findByID(this.id).then(response => {
                
                this.data = response.data

                this.data.supplier_id = this.data.supplier.id;
                this.pushSupplier(this.data.supplier);

                this.data.currency_id = this.data.currency.id;
                this.pushCurrency(this.data.currency);

                this.data.ledger_payable_id = this.data.ledger_payable.id;
                this.pushLedgerAccount(this.data.ledger_payable);

                this.data.ledger_prepaid_id = this.data.ledger_prepaid.id;
                this.pushLedgerAccount(this.data.ledger_prepaid);

            }).catch(error => {

                let message = error.response ? error.response.data.message : error;
                this.snackbar({ text: message, color: "error"});

            }).finally(() => {

                this.loading = false;

            })
        }
    },
    mounted() {
        this.id = this.$route.params.id;
        this.fetchSupplierAccount();
    }

}
</script>

<style>

</style>